// extracted by mini-css-extract-plugin
export default {"image":"MapView_image__p9r3K"};